import type { Navigation } from '@kaba/shared';
import type { Target } from '../../lib/structure';

const enc = (t: Target) => (t.areaId ? `${t.areaId}|${t.folderId ?? ''}` : '');
const dec = (v: string): Target => {
  if (!v) return { areaId: null, folderId: null };
  const [a, f] = v.split('|');
  return { areaId: a!, folderId: f || null };
};

/** Zielauswahl für neue und importierte Boards (B01, A03): Nicht einsortiert, Bereich oder Ordner */
export function PlacementSelect({ nav, value, onChange, id }: { nav: Navigation | undefined; value: Target; onChange: (t: Target) => void; id: string }) {
  const teams = [...new Map((nav?.areas ?? []).map((a) => [a.teamId, a.teamName])).entries()];
  return (
    <select
      id={id}
      value={enc(value)}
      onChange={(e) => onChange(dec(e.target.value))}
      className="min-h-11 rounded-lg border border-[var(--line)] bg-[var(--panel)] px-3 text-base font-normal sm:text-sm"
    >
      <option value="">Nicht einsortiert</option>
      {teams.map(([teamId, teamName]) => (
        <optgroup key={teamId} label={teams.length > 1 ? `Team ${teamName}` : 'Bereiche'}>
          {nav!.areas
            .filter((a) => a.teamId === teamId)
            .flatMap((a) => [
              <option key={a.id} value={enc({ areaId: a.id, folderId: null })}>
                {a.name}
              </option>,
              ...a.folders.map((f) => (
                <option key={f.id} value={enc({ areaId: a.id, folderId: f.id })}>
                  {a.name} / {f.name}
                </option>
              )),
            ])}
        </optgroup>
      ))}
    </select>
  );
}
